import { z } from 'zod';
import { queuePoolSchema, queueStatsSchema } from '../queueShared';

export const cropQueueJobSchema = z.object({
  id: z.number(),
  clipId: z.number(),
  vaultPath: z.string(),
  startMs: z.number(),
  endMs: z.number(),
  outputFilename: z.string(),
  status: z.string(),
  retryCount: z.number(),
  error: z.string().nullable(),
  createdAt: z.string(),
  startedAt: z.string().nullish(),
  completedAt: z.string().nullish(),
});

export type ICropQueueJob = z.infer<typeof cropQueueJobSchema>;

export const fetchCropQueueResponseSchema = z.object({
  pool: queuePoolSchema,
  stats: queueStatsSchema,
  jobs: z.array(cropQueueJobSchema),
});

export type IFetchCropQueueResponse = z.infer<typeof fetchCropQueueResponseSchema>;
